// extracted by mini-css-extract-plugin
module.exports = {"shortText":"SectionPriceList_shortText__grD_E"};